export default "__VITE_ASSET__89lrHJUo__"